import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import { type ILink } from 'uplisting-frontend/components/ui/nav-links';

export default class AiMessagingController extends BaseController {
  @service featureFlags!: Services['feature-flags'];

  @cached
  get navLinks(): ILink[] {
    const { intl } = this;

    const isPermitted =
      this.currentUser.hasAccessTo('ai_drafts.create') &&
      this.featureFlags.gate.enabled('ai_messaging');

    return [
      {
        name: intl.t('nav_links.ai_messaging.controls'),
        route: 'ai-messaging.controls',
        permitted: isPermitted,
      },
      {
        name: intl.t('nav_links.ai_messaging.knowledge_center'),
        route: 'ai-messaging.knowledge-center',
        permitted: isPermitted,
      },
      {
        name: intl.t('nav_links.ai_messaging.content_files'),
        route: 'ai-messaging.content-files',
        permitted: isPermitted,
      },
    ];
  }
}
